{
  "addFleet": "Flotte hinzufügen",
  "table": {
    "empty": "Keine Flotte gefunden",
    "column": {
      "fleet": "Flotte",
      "devices": "Geräte",
      "createdAt": "Erstellt am",
      "updatedAt": "Aktualisiert am",
      "incompatibleDevices": "Inkompatible Geräte",
      "information": {
        "incompatibleDevices": "Einige Geräte der Flotte sind nicht mit den aktuellen Parametern kompatibel.",
        "fleetHasChanged": "Der Flottenumfang wurde geändert",
        "noDeviceCompatible": "Kein Gerät dieser Flotte ist mit der aktuellen Kampagnenparametrierung kompatibel"
      }
    }
  },
  "addDevices": "Geräte hinzufügen",
  "form": {
    "createFleet": {
      "header": "Eine neue Flotte erstellen",
      "validate": "Flotte erstellen",
      "cancel": {
        "confirmMessage": "Möchten Sie die Erstellung der Flotte wirklich abbrechen?"
      }
    },
    "validation": {
      "name": "Der Name ist erforderlich",
      "uniqueName": "Der Flottenname muss eindeutig sein"
    },
    "header": {
      "addDevices": "Fügen Sie ausgewählte Geräte zu einer Flotte hinzu",
      "createFleet": "Eine Flotte erstellen"
    },
    "newFleet": "Neue Flotte",
    "name": "Flottenname",
    "saveSuccess": "Die {fleetName}-Flotte wurde erfolgreich erstellt."
  },
  "attachDevices": {
    "updateSuccess": "Kein Gerät hinzugefügt | Das Hinzufügen des Geräts zur {fleetName}-Flotte war erfolgreich. | Das Hinzufügen der Geräte zur {fleetName}-Flotte war erfolgreich.",
    "title": "Geräte zur Flotte hinzufügen",
    "confirmMessage": "Möchten Sie den Vorgang wirklich abbrechen? Ihre Auswahl geht verloren."
  },
  "removeDevices": {
    "confirmMessage": "Möchten Sie dieses Gerät wirklich aus dieser Flotte entfernen? | Sind Sie sicher, dass Sie dieses Gerät aus dieser Flotte entfernen möchten? | Sind Sie sicher, dass Sie diese Geräte aus der Flotte entfernen möchten?",
    "confirmTitle": "Aus der Flotte entfernen"
  },
  "actionForbidden": "Sie verfügen nicht über die für diese Aktion erforderliche Berechtigung.",
  "delete": {
    "title": "Flotte löschen",
    "confirm": {
      "message": "Möchten Sie die ausgewählte Flotte wirklich löschen?"
    }
  },
  "quickActions": {
    "selectedFleets": "Keine Flotte ausgewählt | {count} Flotte ausgewählt | {count} ausgewählte Flotten",
    "delete": {
      "title": "Keine Flotte zum Löschen | Eine Flotte löschen | Flotten löschen"
    }
  },
  "bulkDelete": {
    "confirm": {
      "title": "Keine Flotte zum Löschen | Flotte löschen | Flotten löschen",
      "message": "Keine Flotte zum Löschen | Möchten Sie die ausgewählte Flotte wirklich löschen? | Möchten Sie die ausgewählten Flotten wirklich löschen?"
    }
  }
}
